import { useEffect, useRef } from "react";
import * as filestack from "filestack-js";
import { filestackConfig, FilestackHookProps } from "./filestackConfig";

interface HookReturn {
  openPicker: () => void;
}

export const useFilestack = ({
  mediaType,
  apiKey,
  onUploadDone,
  onUploadFailed,
  storageOptions,
  onHide,
}: FilestackHookProps): HookReturn => {
  const client = useRef<filestack.Client | null>(null);

  const baseConfig = filestackConfig[mediaType];

  useEffect(() => {
    const options = {};

    if (!client.current) {
      const filestackClient = filestack.init(apiKey, options);
      client.current = filestackClient;
    }
  }, [apiKey]);

  const openPicker = () => {
    if (client.current) {
      client.current
        .picker({
          ...baseConfig,
          fromSources: ["local_file_system", "url"],
          storeTo: storageOptions || undefined,
          displayMode: filestack.PickerDisplayMode.inline,
          onUploadDone: (files) => {
            onUploadDone(files);
            onHide();
          },
          onFileUploadFailed: onUploadFailed,
        })
        .open();
    }
  };

  return {
    openPicker,
  };
};
